import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import ModalHeader from '../common/modal/header';
import DotLoader from '@/common/dot-loader';

const ProfileDeletionModal = ({ closeModal, headoffice }) => {
    const [t] = useTranslation('common');
    const [status, setStatus] = useState('pending'); // "pending" | "loading" | "failed" | "success"

    const wasSuccess = status === 'success';
    const isLoading = status === 'loading';

    const onClick = () => {
        setStatus('loading');
        Mobi2Go.Customer.requestProfileDeletion()
            .then(res => setStatus('success'))
            .catch(err => {
                setStatus('failed');
            });
    };

    return (
        <div className="m2g-profile-deletion">
            <ModalHeader
                headerText={t('customer.profile-deletion:mobile_page_title')}
                onClose={closeModal}
                hideCloseButton={false}
            />
            {wasSuccess ? (
                <div className="m2g-modal-body m2g-text--center">
                    {t('customer.profile-deletion:profile_deletion_confirmed')}
                </div>
            ) : (
                <div className="m2g-modal-body m2g-text--center">
                    {$('<div />').html(t('customer.profile-deletion:profile_deletion_question', {
                        headoffice: headoffice.display_name
                    })).text()}
                </div>
            )}

            <div className="m2g-modal-footer">
                <div className="m2g-modal-footer-right">
                    {wasSuccess ? (
                        <button className="m2g-button" onClick={closeModal}>
                            {t('ok')}
                        </button>
                    ) : (
                        <>
                            <button
                                disabled={isLoading}
                                className="m2g-button m2g-button--primary"
                                onClick={onClick}
                            >
                                {isLoading ? (
                                    <DotLoader dotCharacter="•" />
                                ) : (
                                    t('yes')
                                )}
                            </button>
                            <button
                                disabled={isLoading}
                                className="m2g-button m2g-button--secondary"
                                onClick={closeModal}
                            >
                                {t('no')}
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProfileDeletionModal;
